import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Flex, Box } from 'rebass/styled-components';

import { Profile } from './steps/profile';
import { useOnboarding } from './hooks/useOnboarding';
import { Stepper } from './components/stepper';
import { NetworkKind } from './steps/networkKinds';
import { Goals } from './steps/goals';
import { Integrations } from './steps/integrations';
import { ShareContacts } from './steps/shareContacts';
import { Team } from './steps/team';

const Walkthrough = () => {
  const {
    isLoadingUpdateUser,
    updateUserProfile,
    handleNextStep,
    goals,
    users,
    setUsers,
    setGoals,
    activeNetwork,
    updateUserGoals,
    isLoadingUpdateUserGoals,
    isLoadingUpdateNetworkKind,
    isLoadingAddAdmin,
    networkKind,
    updateNetworkKind,
    updateGoals,
    user,
    updateTeam,
    showNetworkKindStep,
    profileMode,
    params,
    shouldShowShareContactsStep,
    handleGoogleSyncComplete,
    steps,
  } = useOnboarding();

  return (
    <Box>
      {activeNetwork && <Stepper steps={steps} slug={activeNetwork.slug} />}
      <Flex
        sx={{
          gap: '56px',
          flexDirection: 'column',
          px: '16px',
          mx: 'auto',
          height: '100%',
        }}
      >
        <Switch>
          <Route
            exact
            path={[
              '/networks/:networkSlug/welcome/onboarding/profile',
              '/networks/:networkSlug/company/:employerSlug/welcome/onboarding/profile',
            ]}
          >
            <Redirect
              to={
                params.employerSlug
                  ? `/networks/${activeNetwork.slug}/company/${params.employerSlug}/welcome/onboarding/profile/${profileMode}`
                  : `/networks/${activeNetwork.slug}/welcome/onboarding/profile/${profileMode}`
              }
            />
          </Route>
          <Route
            exact
            path={[
              '/networks/:networkSlug/welcome/onboarding/profile/:mode',
              '/networks/:networkSlug/company/:employerSlug/welcome/onboarding/profile/:mode',
            ]}
          >
            <Profile
              isLoadingUpdateUser={isLoadingUpdateUser}
              updateUserProfile={updateUserProfile}
              network={activeNetwork}
              user={user}
            />
          </Route>
          <Route exact path="/networks/:networkSlug/welcome/onboarding/network-kind">
            {showNetworkKindStep ? (
              <NetworkKind
                handleNextStep={handleNextStep}
                networkKind={networkKind}
                network={activeNetwork}
                isLoadingUpdateNetworkKind={isLoadingUpdateNetworkKind}
                updateNetworkKind={updateNetworkKind}
              />
            ) : (
              <Redirect to={`/networks/${activeNetwork.slug}/welcome/onboarding/goals`} />
            )}
          </Route>
          <Route exact path="/networks/:networkSlug/welcome/onboarding/goals">
            <Goals
              handleNextStep={handleNextStep}
              goals={goals}
              updateUserGoals={updateUserGoals}
              isLoadingUpdateUserGoals={isLoadingUpdateUserGoals}
              setGoals={setGoals}
              network={activeNetwork}
              updateGoals={updateGoals}
              kind={networkKind}
            />
          </Route>
          <Route exact path="/networks/:networkSlug/welcome/onboarding/integrations">
            <Integrations
              handleNextStep={handleNextStep}
              activeNetwork={activeNetwork}
              handleGoogleSyncComplete={handleGoogleSyncComplete}
            />
          </Route>
          <Route exact path="/networks/:networkSlug/welcome/onboarding/share-contacts">
            {shouldShowShareContactsStep ? (
              <ShareContacts handleNextStep={handleNextStep} activeNetwork={activeNetwork} />
            ) : (
              <Redirect
                to={
                  steps.includes('team')
                    ? `/networks/${activeNetwork?.slug || params?.networkSlug}/welcome/onboarding/team`
                    : `/networks/${activeNetwork?.slug || params?.networkSlug}/home`
                }
              />
            )}
          </Route>
          <Route exact path="/networks/:networkSlug/welcome/onboarding/team">
            <Team users={users} setUsers={setUsers} isLoadingAddAdmin={isLoadingAddAdmin} updateTeam={updateTeam} />
          </Route>
        </Switch>
      </Flex>
    </Box>
  );
};

export default Walkthrough;
